function fileFromField(value) {
  if (!value) {
    return undefined;
  }
  if (value instanceof File) {
    return value;
  }
  if (Array.isArray(value) && value[0] instanceof File) {
    return value[0];
  }
  return undefined;
}

export function buildReceivingInvoicePayload(values) {
  const payload = {
    invoice_number: values.invoice_number,
    truck_selected: values.truck_selected,
    supplier_selected: values.supplier_selected,
    carrier_selected: values.carrier_selected,
    created_by: values.created_by?.value,
    status: values.statusSelected?.value,
    truck_question_1: values.truck_question_1?.value,
    truck_question_2: values.truck_question_2?.value,
    truck_question_3: values.truck_question_3?.value,
    truck_question_4: values.truck_question_4?.value,
  };

  const document1 = fileFromField(values.document_1);
  if (document1) {
    payload.document_1 = document1;
  }

  const document2 = fileFromField(values.document_2);
  if (document2) {
    payload.document_2 = document2;
  }

  return payload;
}
